import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';

const ItemLayout: React.FC = ({
  children,
}) => (
  <Box
    borderColor={colors.grey3}
    borderBottomWidth={1}
    borderStyle="solid"
    paddingX={16}
    paddingY={20}
  >
    {children}
  </Box>
);

export default ItemLayout;
